//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
// defrag daily results card imports
import { IProps, IState, IContainer } from "./TailoredDefragSummarySurveyDialog.d";
import * as s from "./TailoredDefragSummarySurveyDialog.styles";
// other components
import { SidebarDialog } from "@clockwise/web-commons/src/components/sidebar-dialog";
import { H2 } from "@ui";
// util
import { track, TrackingEvents } from "@util/analytics.util";
// state
import { snackBarOpen } from "@actions/snack-bar.actions";
import { IReduxState } from "@state/reducers/root.reducer";
import { Button, DialogActions, DialogContent, TextField } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { TranslationContext } from "@clockwise/client-commons/src/providers/TranslationContext";

//////////////////
// COMPONENT
//////////////////
class TailoredDefragSummarySurveyDialogComponent extends React.PureComponent<IProps, IState> {
  static contextType = TranslationContext;
  declare context: React.ContextType<typeof TranslationContext>;

  constructor(props: IProps) {
    super(props);
    this.state = {
      selectedReasons: [],
      otherReasonChecked: false,
      otherReason: "",
      additionalComments: "",
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private closeDialog = (sendFeedback: boolean) => {
    const { selectedReasons, otherReasonChecked, otherReason, additionalComments } = this.state;
    this.props.onClose(
      sendFeedback,
      selectedReasons,
      otherReasonChecked,
      otherReason,
      additionalComments,
    );
    track(TrackingEvents.DEFRAG.SEND_SURVEY_RESPONSE, {
      selectedReasons,
      additionalComments,
      otherReason: otherReasonChecked ? otherReason : "",
    });
  };

  private onAdditionalCommentsChange = (event: any) => {
    this.setState({ additionalComments: event.target.value });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  public render() {
    const t = this.context;

    return (
      <SidebarDialog
        open={this.props.open}
        onClose={() => this.closeDialog(false)}
        isChromeExtension={this.props.isChromeExtension}
      >
        <DialogContent
          classes={{
            root: this.props.classes.dialog,
          }}
        >
          <div>
            <H2 style={s.styles.header}>{t("defrag-summary:survey-title")}</H2>
            <div className={this.props.classes.textFieldContainer}>
              <TextField
                label={`Why weren't these changes helpful?`}
                value={this.state.additionalComments}
                onChange={this.onAdditionalCommentsChange}
                fullWidth
                multiline
                autoFocus
                InputLabelProps={{
                  shrink: true,
                  classes: {
                    root: this.props.classes.labelInputRoot,
                  },
                }}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={() => this.closeDialog(true)} color="primary">
            Send Feedback
          </Button>
          <Button variant="text" onClick={() => this.closeDialog(false)}>
            Cancel
          </Button>
        </DialogActions>
      </SidebarDialog>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
const TailoredDefragSummarySurveyDialogStyled = withStyles(s.styles)(
  TailoredDefragSummarySurveyDialogComponent,
);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

export const TailoredDefragSummarySurveyDialog = connect(mapStateToProps, {
  snackBarOpen,
})(TailoredDefragSummarySurveyDialogStyled);
